import { FC } from "react";
import { StyledThumbnail } from "./Thumbnail.styles";
import { AllieThumbnailProps } from "./Thumbnail.types";

export const AllieThumbnail: FC<AllieThumbnailProps> = ({
  borderRadius = 14,
  size = 140,
  ...props
}) => <StyledThumbnail borderRadius={borderRadius} size={size} {...props} />;
